/* Bumberry — shared site behaviour (no dependencies) */
(function () {
  'use strict';

  /* ---- scroll reveal ---- */
  function initReveal() {
    // the homepage runs its own directional reveals in home.js
    if (document.querySelector('.site-header--home')) return;
    var targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(targets, function (el) { io.observe(el); });
    window.bumberryObserve = function (el) { io.observe(el); };
  }

  /* ---- mobile drawer ---- */
  function initDrawer() {
    var btn = document.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function () { drawer.classList.toggle('is-open'); });
    Array.prototype.forEach.call(drawer.querySelectorAll('a'), function (a) {
      a.addEventListener('click', function () { drawer.classList.remove('is-open'); });
    });
  }

  /* ---- collection filters ---- */
  function initFilters() {
    var chips = document.querySelectorAll('[data-filter]');
    var cards = document.querySelectorAll('[data-cat]');
    var count = document.querySelector('[data-count]');
    if (!chips.length || !cards.length) return;

    function apply(key) {
      var shown = 0;
      Array.prototype.forEach.call(cards, function (card) {
        var match = key === 'all' || card.getAttribute('data-cat') === key;
        card.style.display = match ? '' : 'none';
        if (match) {
          shown++;
          if (!card.classList.contains('in') && window.bumberryObserve) window.bumberryObserve(card);
        }
      });
      if (count) count.textContent = shown + (shown === 1 ? ' product' : ' products');
      Array.prototype.forEach.call(chips, function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-filter') === key);
      });
    }

    Array.prototype.forEach.call(chips, function (chip) {
      chip.addEventListener('click', function () { apply(chip.getAttribute('data-filter')); });
    });
    apply('all');
  }

  function boot() {
    initReveal();
    initDrawer();
    initFilters();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Bumberry homepage — nav state, mega menus, parallax, floats, journey (no dependencies) */
(function () {
  'use strict';

  var TAGLINES = ['Easy on babies,\neasier on the planet.', 'Care that grows\nwith your baby.'];
  var tagIndex = 0;

  function initTagline() {
    var el = document.querySelector('[data-hero-title]');
    var btn = document.querySelector('[data-tagline-swap]');
    if (!el) return;
    el.textContent = TAGLINES[0];
    if (!btn) return;
    btn.addEventListener('click', function () {
      tagIndex = (tagIndex + 1) % TAGLINES.length;
      el.style.opacity = '0';
      setTimeout(function () {
        el.textContent = TAGLINES[tagIndex];
        el.style.opacity = '1';
      }, 220);
    });
    el.style.transition = 'opacity .22s ease';
  }

  function initNavState() {
    var header = document.querySelector('.site-header--home');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initMegaMenus() {
    var header = document.querySelector('.site-header--home');
    if (!header) return;
    var triggers = document.querySelectorAll('[data-mega-open]');
    var menus = document.querySelectorAll('.mega');

    function close() {
      Array.prototype.forEach.call(menus, function (m) { m.classList.remove('is-open'); });
    }
    Array.prototype.forEach.call(triggers, function (t) {
      t.addEventListener('mouseenter', function () {
        close();
        var target = document.getElementById(t.getAttribute('data-mega-open'));
        if (target) target.classList.add('is-open');
      });
    });
    document.querySelectorAll('[data-mega-close]').forEach(function (el) {
      el.addEventListener('mouseenter', close);
    });
    header.addEventListener('mouseleave', close);
  }

  /* one rAF loop drives parallax, promise floats and the journey camera */
  function initMotion() {
    var pTargets = Array.prototype.map.call(document.querySelectorAll('[data-parallax]'), function (el) {
      var r = el.getBoundingClientRect();
      return {
        el: el,
        speed: parseFloat(el.getAttribute('data-parallax')) || 0.08,
        top: r.top + window.scrollY,
        scale: el.getAttribute('data-parallax-scale') || '1.18'
      };
    });

    var promiseSec = document.getElementById('promise');
    var floats = Array.prototype.slice.call(document.querySelectorAll('.promise-float'));
    var floatCur = 0, floatTarget = 0;
    var floatTravel = window.innerHeight * 1.3;
    var nFloats = floats.length;

    function computeFloat() {
      if (!promiseSec) return;
      var rect = promiseSec.getBoundingClientRect();
      var total = promiseSec.offsetHeight - window.innerHeight;
      floatTarget = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
    }

    var jSec = document.getElementById('journey');
    var jWorld = document.getElementById('journeyWorld');
    var jHills = document.getElementById('journeyHills');
    var jDots = Array.prototype.slice.call(document.querySelectorAll('.j-dot'));
    var jCur = 0, jTarget = 0;

    function computeJ() {
      if (!jSec) return;
      var rect = jSec.getBoundingClientRect();
      var total = jSec.offsetHeight - window.innerHeight;
      jTarget = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
    }

    /* gentle snap to the nearest scene when scrolling stops */
    var snapTimer = null;
    function maybeSnap() {
      if (!jSec) return;
      clearTimeout(snapTimer);
      snapTimer = setTimeout(function () {
        var total = jSec.offsetHeight - window.innerHeight;
        if (total <= 0) return;
        var top = jSec.offsetTop;
        var sy = window.scrollY;
        if (sy < top - 2 || sy > top + total + 2) return;
        var progress = Math.min(1, Math.max(0, (sy - top) / total));
        var snaps = [0, 1 / 3, 2 / 3, 1];
        var nearest = snaps[0], best = Infinity;
        snaps.forEach(function (s) {
          var d = Math.abs(s - progress);
          if (d < best) { best = d; nearest = s; }
        });
        var targetY = top + nearest * total;
        if (Math.abs(targetY - sy) > 2) window.scrollTo({ top: targetY, behavior: 'smooth' });
      }, 130);
    }

    window.addEventListener('scroll', function () { computeFloat(); computeJ(); maybeSnap(); }, { passive: true });
    window.addEventListener('resize', function () { computeFloat(); computeJ(); });
    computeFloat();
    computeJ();

    var lerp = window.scrollY;
    var lastScroll = -1;

    function loop() {
      var changed = window.scrollY !== lastScroll;
      lastScroll = window.scrollY;
      lerp += (window.scrollY - lerp) * 0.09;

      pTargets.forEach(function (t) {
        var ty = (lerp - t.top) * t.speed;
        t.el.style.transform = 'scale(' + t.scale + ') translateY(' + ty.toFixed(1) + 'px)';
      });

      if (nFloats) {
        floatCur += (floatTarget - floatCur) * 0.06;
        if (changed || Math.abs(floatTarget - floatCur) > 0.001) {
          floats.forEach(function (el) {
            var fx = parseFloat(el.getAttribute('data-fx')) || 0;
            var seq = parseFloat(el.getAttribute('data-seq')) || 0;
            var span = 1 / nFloats;
            var local = Math.min(1, Math.max(0, (floatCur - seq * span) / span));
            var y = floatTravel * local, x = fx * 150 * local, rot = fx * 14 * local;
            el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + (-y).toFixed(1) + 'px,0) rotate(' + rot.toFixed(1) + 'deg)';
          });
        }
      }

      if (jWorld) {
        jCur += (jTarget - jCur) * (window.innerWidth <= 900 ? 0.16 : 0.07);
        if (Math.abs(jTarget - jCur) < 0.002) jCur = jTarget;
        if (changed || Math.abs(jTarget - jCur) > 0.0005) {
          jWorld.style.transform = 'translate3d(' + (-jCur * 75).toFixed(3) + '%,0,0)';
          if (jHills) jHills.style.transform = 'translate3d(' + (-jCur * 66).toFixed(3) + '%,0,0)';
          var scene = Math.min(3, Math.floor(jCur * 4 * 0.999));
          jDots.forEach(function (d, i) { d.classList.toggle('is-active', i === scene); });
        }
      }
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  }

  /* directional reveals (up / left / right / scale) */
  function initReveals() {
    var ease = 'cubic-bezier(.16,1,.3,1)';
    var initial = {
      up: 'translateY(40px)',
      left: 'translateX(-54px)',
      right: 'translateX(54px)',
      scale: 'scale(.9) translateY(28px)'
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.opacity = '1';
        e.target.style.transform = 'none';
        io.unobserve(e.target);
        setTimeout(function () { e.target.style.transform = ''; }, 1100);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      var type = el.getAttribute('data-reveal') || 'up';
      el.style.opacity = '0';
      el.style.transform = initial[type] || initial.up;
      el.style.transition = 'opacity .9s ' + ease + ', transform 1.05s ' + ease;
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) {
        return c.hasAttribute('data-reveal');
      });
      el.style.transitionDelay = (Math.max(0, sibs.indexOf(el)) * 0.085) + 's';
      io.observe(el);
    });
  }

  function boot() {
    initTagline();
    initNavState();
    initMegaMenus();
    initReveals();
    initMotion();
  }

  

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();



function initAccordions() {
  const items = document.querySelectorAll('.acc__item');

  items.forEach(item => {
    const btn = item.querySelector('.acc__btn');
    const sign = item.querySelector('.acc__sign');

    if (!btn) return;

    btn.addEventListener('click', function () {

      const isOpen = item.classList.contains('is-open');

      items.forEach(el => {
        el.classList.remove('is-open');

        const s = el.querySelector('.acc__sign');
        if (s) s.textContent = '+';
      });

      if (!isOpen) {
        item.classList.add('is-open');
        if (sign) sign.textContent = '−';
      }

    });
  });
}

document.addEventListener('DOMContentLoaded', initAccordions);


function initScrollStory() {
  const story = document.querySelector(".sv-story");
  const video = story?.querySelector("video");
  const panels = [...document.querySelectorAll(".sv-panel")];

  if (!story || !video || !panels.length) return;

  let duration = 0;
  let target = 0;
  let current = 0;
  let raf = null;

  video.addEventListener("loadedmetadata", () => {
    duration = video.duration || 0;
  });

  function getProgress() {
    const rect = story.getBoundingClientRect();
    const total = story.offsetHeight - window.innerHeight;

    if (total <= 0) return 0;

    return Math.max(0, Math.min(1, -rect.top / total));
  }

  function updatePanels(progress) {
    const totalPanels = panels.length;

    let index = Math.floor(progress * totalPanels);

    if (index >= totalPanels) {
      index = totalPanels - 1;
    }

    panels.forEach((panel, i) => {
      panel.classList.toggle("is-active", i === index);
    });
  }

  function tick() {
    raf = null;

    current += (target - current) * 0.12;

    if (duration > 0) {
      const time = current * duration;

      if (Math.abs(video.currentTime - time) > 0.02) {
        try {
          video.currentTime = time;
        } catch (e) {}
      }
    }

    if (Math.abs(target - current) > 0.001) {
      raf = requestAnimationFrame(tick);
    }
  }

  function onScroll() {
    target = getProgress();

    updatePanels(target);

    if (!raf) {
      raf = requestAnimationFrame(tick);
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);

  onScroll();
}

document.addEventListener("DOMContentLoaded", initScrollStory);